import { GA_PRODUCT, GA_CONTAINER_ID } from './types';
export const isBrowser = () => typeof window !== 'undefined';
export const gtagFallback = () => {
    if (isBrowser() && !window.gtag) {
        window.gtag = () => {
            console.debug('gtag called without ga4 being initialized');
            return;
        };
    }
};
export const whichProduct = (path) => {
    let product = GA_PRODUCT.DEFAULT_S4MP;
    if (path === null || path === void 0 ? void 0 : path.match(new RegExp('^/catalog($|/.*)'))) {
        product = GA_PRODUCT.CATALOG;
    }
    else if (path === null || path === void 0 ? void 0 : path.match(new RegExp('^/deliveries($|/.*)'))) {
        product = GA_PRODUCT.DELIVERIES;
    }
    else if (path === null || path === void 0 ? void 0 : path.match(new RegExp('^/ppp($|/.*)'))) {
        product = GA_PRODUCT.PPP;
    }
    else if (path === null || path === void 0 ? void 0 : path.match(new RegExp('^/upload($|/.*)'))) {
        product = GA_PRODUCT.UPLOAD;
    }
    return product;
};
export const sendPageView = (path) => {
    const product = whichProduct(path);
    sendEvent({
        pagePath: path,
        pageTitle: product,
        product,
    }, 'pageview');
};
export function sendEvent(event, eventName = 'GAEvent') {
    gtagFallback();
    window.gtag('event', eventName, Object.assign({}, event));
}
export function setUserProperties(properties) {
    gtagFallback();
    window.gtag('set', 'user_properties', {
        isEmployee: properties.isEmployee,
        isTestUser: properties.isTestUser,
        organizations: properties.organizations,
    });
}
export function insertIntoHead(nonce) {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_CONTAINER_ID}`;
    if (script.nonce) {
        script.nonce = nonce;
    }
    document.head.appendChild(script);
    const setupScript = document.createElement('script');
    setupScript.text = `window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${GA_CONTAINER_ID}');`;
    document.head.appendChild(setupScript);
}
//# sourceMappingURL=index.js.map